import React from 'react';
import { openVaultGate } from '../../store/vaultStore';

/**
 * "The Vault is locked. [Unlock Vault…]" where a dialog needs a sign-in from
 * the Vault (Connect / Add a remote / Clone). Owner decision 05.10.2026: the
 * dialog used to say "Unlock the Vault to choose a sign-in" with no way to do
 * it, so the user had to close it, unlock elsewhere and start over. Password
 * managers and IDEs ask for the master password in place instead (1Password /
 * Bitwarden in-context unlock, JetBrains' master-password prompt), so this
 * opens the always-mounted passphrase gate above the dialog. After the unlock
 * the gate refreshes the vault store, and the caller's picker replaces this.
 */
export default function VaultUnlockInline({ disabled, reason = 'git-remote' }) {
  return (
    <div className="flex items-center gap-2">
      <p className="text-xs text-gray-500">The Vault is locked.</p>
      <button type="button" className="git-btn git-btn--ghost" onClick={() => openVaultGate(reason)} disabled={disabled}>
        Unlock Vault…
      </button>
    </div>
  );
}
